import { IAction } from '../models/action';
import { REMOVE_POST_SUCCESS, UPDATE_POST_SUCCESS, ADD_POST_SUCCESS, REQUEST_POSTS_SUCCESS, UPDATE_LIKE_SUCCESS, ADD_COMMENT_SUCCESS, REMOVE_COMMENT_SUCCESS, REQUEST_POSTS_METADATA_SUCCESS, REQUEST_POST_SUCCESS } from '../handlers.actions';

const initPostsStore: any = () => ([]);
const initPostMetadataStore: any = () => ({
     totalDocs: 0,
     limit: 0,
     totalPages: 0,
     page: 0,
     pagingCounter: 0,
     hasPrevPage: false,
     hasNextPage: false,
     prevPage: null,
     nextPage: 0
});

/** POSTS REDUCER */
export const postReducer = (state = initPostsStore(), action: IAction) => {
    switch (action.type) {
          case ADD_POST_SUCCESS:
          case REQUEST_POST_SUCCESS:
              return [ ...state.slice(0, action.payload), action.payload, ...state.slice(action.payload)];

         case UPDATE_POST_SUCCESS:               
              return state.map((post: any) => (post._id === action.payload._id)? action.payload: post);
              
          case UPDATE_LIKE_SUCCESS:               
               return state.map((post: any) => (post._id === action.payload._id)? action.payload: post);

         case REMOVE_POST_SUCCESS:               
              return state.filter((post: any) => post._id !== action.payload);

          case ADD_COMMENT_SUCCESS:
               return state.map((post: any) => (post._id === action.payload.post._id)? action.payload.post: post);

          case REMOVE_COMMENT_SUCCESS:               
              return state.map((post: any) => (post._id === action.payload.post._id)? action.payload.post: post);

          case REQUEST_POSTS_SUCCESS:                             
              return [...state, ...action.payload];
          default:
              return state;
    }
};

export const postMetadataReducer = (state = initPostMetadataStore(), action:IAction) => {
     const {type, payload} = action;
     switch(type){
          case REQUEST_POSTS_METADATA_SUCCESS:
               return {...payload};
          default:
               return state;
     }
}